/**
 * Initializes the side-drawer slide-out UIs.
 */
export function initDrawer() {
    setupDrawer('open-rankings-btn', 'close-rankings-btn', 'rankings-drawer', 'drawer-backdrop');
    setupDrawer('open-builds-btn', 'close-builds-btn', 'builds-drawer', 'builds-drawer-backdrop');
}

function setupDrawer(openBtnId, closeBtnId, drawerId, backdropId) {
    const openBtn = document.getElementById(openBtnId);
    const closeBtn = document.getElementById(closeBtnId);
    const drawer = document.getElementById(drawerId);
    const backdrop = document.getElementById(backdropId);

    if (!openBtn || !closeBtn || !drawer || !backdrop) return;

    const openDrawer = () => {
        drawer.classList.add('drawer-open');
        backdrop.classList.add('visible');
        backdrop.classList.remove('hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    };

    const closeDrawer = () => {
        drawer.classList.remove('drawer-open');
        backdrop.classList.remove('visible');

        // Wait for CSS transition to finish before hiding backdrop completely
        setTimeout(() => {
            if (!drawer.classList.contains('drawer-open')) {
                backdrop.classList.add('hidden');
                document.body.style.overflow = ''; // Restore scrolling
            }
        }, 300);
    };

    openBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    // Allow escape key to close drawer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('drawer-open')) {
            closeDrawer();
        }
    });
}

